import { NameDto } from '../../Common/Types'
import { WidgetOptions } from './CreateClientAppTest'

export enum clientTestTypes {
  client = 'client',
  ib = 'ib',
  kyc = 'kyc',
  w8beneficial = 'w8beneficial',
  classification = 'classification',
  corporate = 'corporate',
  economicProfile = 'economicProfile',
}

export enum TestSubcategory {
  Individual = 1,
  Company = 2,
  ClassificationProfessional = 3,
  ClassificationExperiencedRetail = 4,
  W8BenIndividual = 5,
  DefaultIb = 6,
  MultiTierIb = 7,
  Reduced = 8,
  Emir = 9,
  AppTestFull = 10,
}

export const getTestSubcategoryByName = (
  testSubcategory: string | null | undefined
): TestSubcategory => {
  switch (testSubcategory) {
    case 'Individual':
      return TestSubcategory.Individual
    case 'Company':
      return TestSubcategory.Company
    case 'Classification Professional':
      return TestSubcategory.ClassificationProfessional
    case 'Classification Experienced Retail':
      return TestSubcategory.ClassificationExperiencedRetail
    case 'W-8BEN Tax Form':
      return TestSubcategory.W8BenIndividual
    case 'Default Ib':
      return TestSubcategory.DefaultIb
    case 'Multi-tier Ib':
      return TestSubcategory.MultiTierIb
    case 'AppTestReduced':
      return TestSubcategory.Reduced
    case 'EMIR':
      return TestSubcategory.Emir
    case 'AppTestFull':
      return TestSubcategory.AppTestFull
    default:
      return TestSubcategory.Individual
  }
}

export enum TestQuestionWidgetType {
  Text = 'text',
  Radio = 'radio',
  Checkbox = 'checkbox',
  ShortText = 'short_text',
  Select = 'select',
  Country = 'country',
  MultiSelect = 'multi_select',
}

export interface TestQuestionWidget {
  name: string | null
  type: TestQuestionWidgetType
  options: string | null
  tooltip: string | null
  errorMessage: string | null
  widgetOptions: WidgetOptions
}

export interface AnswerGroup {
  name: string
  values: string[]
}

export interface TestQuestionDto {
  question: {
    name: string | null
    id: string
  }
  isMandatory: boolean
  order: number
  answers: {
    answerId: string
    name: string | null
    id: string
    code: string
  }[]
  widget: TestQuestionWidget
}

export interface QuestionDto {
  id: string
  name: string | null
  questionId: string
  code: string | null
  section: NameDto
  widgetType: TestQuestionWidgetType
  widgetName: string | null
  text: string | null
  description: string | null
  tooltip: string | null
  errorMessage: string | null
  order: number
}

export enum QuestionWidgetNameType {
  EmploymentPosition = 'employment_position',
  EmployerName = 'employer_name',
  SourceFundOther = 'source_fund_other',
  None = 'none',
}

export const getQuestionWidgetNameType = (
  nameType: string | null | undefined
): QuestionWidgetNameType => {
  switch (nameType) {
    case QuestionWidgetNameType.EmploymentPosition:
      return QuestionWidgetNameType.EmploymentPosition
    case QuestionWidgetNameType.EmployerName:
      return QuestionWidgetNameType.EmployerName
    case QuestionWidgetNameType.SourceFundOther:
      return QuestionWidgetNameType.SourceFundOther
    default:
      return QuestionWidgetNameType.None
  }
}
